var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('loading-component'),_c('file-loading-component'),(_vm.$route.meta.hideNavigation)?_c('div',[_c('Login')],1):_c('div',[_c('AsideMain'),_c('div',{staticClass:"app"},[_c('div',{staticClass:"b-main"},[_c('AppHeader'),_c('router-view')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }